export const HOMEPAGE = "";

// auth routing
export const AUTH = "auth";

//  Rewards Module routing
export const PUBLIC_REWARD_LISTING = "rewards/:integratorId/:subId";
export const PUBLIC_LISTING_PAGE = "offers";
export const REWARD_LISTING = "rewards";
export const BRAND_BUNDLE_PAGE = "brand-bundle";
export const BRAND_BUNDLE_SUMMARY_PAGE = "brand-bundle-summary";

export const REWARD_DETAIL_GIFTCARD_PAGE = "rewards/giftcard/:id/:slugId";
export const REWARD_DETAIL_DISCOUNTOFFER_PAGE = "rewards/discount/:id/:slugId";
export const REWARD_DETAIL_EXPERIENCES_PAGE = "rewards/experience/:id/:slugId";
export const REWARD_DETAIL_MEMBERSHIP_PAGE = "rewards/membership/:id/:slugId";
export const REWARD_DETAIL_CASHBACK_PAGE = "rewards/cashback/:id/:slugId";
export const REWARD_DETAIL_SUBSCRIPTION_OFFER_PAGE = "rewards/subscription/:id/:slugId";

export const PUBLIC_REWARD_DETAIL_PAGE = "rewards/:brandName/:integratorId/:subId/:id";

export const REWARD_SUMMARY_PAGE = "order/:offerType/:id";

// Subscription Module routing
export const SUBSCRIPTION_LISTING = "subscription";
export const ACTIVE_SUBSCRIPTION_DETAILPAGE = "subscription/:id/:slugId/active";
export const INACTIVE_SUBSCRIPTION_DETAILPAGE = "subscription/:id/:slugId/inactive";

// Travel Module routing
export const TRAVEL_MODULE = "travel";
export const TRAVEL_FLIGHT_MODULE = "travel/flight";
export const TRAVEL_BUS_MODULE = "travel/bus";
export const TRAVEL_TRAIN_MODULE = "travel/train";
export const TRAVEL_HOTEL_MODULE = "travel/hotel";
export const TRAVEL_FLIGHT_CONFIRMATION = "travel/flight/:id";

// VIP Module routing
export const VIP_MODULE = "VIP";
export const VIP_DETAIL = "VIP/:id";

// Commerce Module routing
export const COMMERCE_MODULE = "commerce";
export const COMMERCE_DETAIL = "commerce/:id";

// Experience Module routing
export const EXPERIENCE_MODULE = "experience";
export const EXPERIENCE_DETAIL = "experience/:id";

//  User Profile
export const USER_PROFILE_PAGE = "userProfile";

// profile page
export const USER_PROFILE = "userProfile/profile";
export const USER_PROFILE_LOYALTY_PAGE = "userProfile/loyalty";

// user profile reward page
export const USER_PROFILE_REWARD_DISCOUNT_PAGE = "userProfile/reward/discount";
export const USER_PROFILE_REWARD_CASHBACK_PAGE = "userProfile/reward/cashback";
export const USER_PROFILE_REWARD_GIFTCARD_PAGE = "userProfile/reward/giftcard";
export const USER_PROFILE_REWARD_SUBSCRIPTION_PAGE = "userProfile/reward/subscription";
export const USER_PROFILE_REWARD_BUNDLE_PAGE = "userProfile/reward/bundle";

// user profile travel page
export const USER_PROFILE_TRAVEL_FLIGHT_PAGE = "userProfile/travel/flight";
export const USER_PROFILE_TRAVEL_HOTEL_PAGE = "userProfile/travel/hotel";
export const USER_PROFILE_TRAVEL_TRAIN_PAGE = "userProfile/travel/train";
export const USER_PROFILE_TRAVEL_BUS_PAGE = "userProfile/travel/bus";
export const USER_PROFILE_TRAVELLER_INFO_PAGE = "userProfile/travel/traveller-info";
export const USER_PROFILE_TRAVEL_EXPERIENCES_PAGE = "userProfile/travel/experiences";

// user profile subscription page
export const USER_PROFILE_SUBSCRIPTION_PAGE = "userProfile/subscription";

// user profile precious metal page
export const USER_PROFILE_PRECIOUS_METAL_PAGE = "userProfile/precious-metal";

// user profile utility page
export const USER_PROFILE_UTILITIES_PAGE = "userProfile/utilities";

// user profile product marketplace page
export const USER_PROFILE_PRODUCT_MARKETPLACE_PAGE = "userProfile/product-marketplace";

// user profile setting page
export const USER_PROFILE_SETTING_PAGE = "userProfile/setting";

export const ASSIGNED_OFFER_PAGE = "assignedOffer";
export const USER_ORDER_PAGE = "order";
export const USER_REWARD_PAGE = "reward";
export const USER_WISHLIST_PAGE = "wishlist";
export const USER_SETTING_PAGE = "setting";
export const USER_SUBSCRIPTION_PAGE = "subscription";

export const CONTACT_US_PAGE = "contact-us";

export const POLICY_PAGE = "policy";

export const POLICY_PRIVACY_PAGE = "privacyPolicy";

export const TERMS_PAGE = "termsOfUse";

export const FAQ_PAGE = "faq";

export const DISCLAIMER_PAGE = "disclaimer";

export const COOKIE_POLICY_PAGE = "cookiePolicy";

// Precious Metals
export const PRECIOUS_METALS = "precious-metals";
export const PRECIOUS_METALS_PORTFOLIO = "precious-metals/portfolio";
export const PRECIOUS_METALS_MANAGE_HOLDINGS = "precious-metals/manageHoldings";

export const PRECIOUS_METALS_BUY = "precious-metals/buy";
export const PRECIOUS_METALS_BUY_CHECKOUT = "precious-metals/buy/checkout";
export const PRECIOUS_METALS_BUY_SUCCESS = "precious-metals/buy/success/:orderId";
export const PRECIOUS_METALS_BUY_PENDING = "precious-metals/buy/pending";

export const PRECIOUS_METALS_SELL = "precious-metals/manageHoldings/sell";
export const PRECIOUS_METALS_SELL_CHECKOUT = "precious-metals/manageHoldings/sell/checkout";
export const PRECIOUS_METALS_SELL_SUCCESS = "precious-metals/manageHoldings/sell/success/:orderId";
export const PRECIOUS_METALS_SELL_PENDING = "precious-metals/manageHoldings/sell/pending";

export const PRECIOUS_METALS_PHYSICAL_DELIVERY = "precious-metals/manageHoldings/physicalDelivery";
export const PRECIOUS_METALS_PHYSICAL_DELIVERY_CHECKOUT = "precious-metals/manageHoldings/physicalDelivery/checkout";
export const PRECIOUS_METALS_PHYSICAL_DELIVERY_SUCCESS = "precious-metals/manageHoldings/physicalDelivery/success/:orderId";
export const PRECIOUS_METALS_PHYSICAL_DELIVERY_PENDING = "precious-metals/manageHoldings/physicalDelivery/pending";

export const PRECIOUS_METALS_GIFT = "precious-metals/manageHoldings/gift";
export const PRECIOUS_METALS_GIFT_CHECKOUT = "precious-metals/manageHoldings/gift/checkout";
export const PRECIOUS_METALS_GIFT_SUCCESS = "precious-metals/manageHoldings/gift/success/:orderId";
export const PRECIOUS_METALS_GIFT_PENDING = "precious-metals/manageHoldings/gift/pending";
